import { Empty } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { api } from "@/lib/api"
import { cardClass, InvoiceRow } from "../plans/billing-details"
import { SettingsHeader } from "../settings-header"

export function PlansInvoicesPage() {
	const { data } = api.workspace.billingDetails.useQuery({ invoiceLimit: 100 })

	return (
		<>
			<MetaInfo title="Invoices" />

			<SettingsHeader
				title="Invoices"
				subtitle="Every invoice we issued for this workspace."
			/>

			{data && data.invoices.length === 0 ? (
				<Empty
					title="No invoices yet"
					text="Invoices show up here once your first payment goes through."
				/>
			) : (
				<div className={`${cardClass} mb-8`}>
					{data?.invoices.map((invoice) => (
						<InvoiceRow key={invoice.id} invoice={invoice} />
					))}
				</div>
			)}
		</>
	)
}
